<script>

    import { replace } from 'svelte-spa-router'
    import { toast } from 'bulma-toast'

    import { userStore } from '../stores'

    import UsersService from '../$services/users.service'
    import Spinner from '../$components/spinner.svelte'

    let data = {}
    let loading = false

    async function login() {

        loading = true
        const resp = await UsersService.userLogin(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        const user = resp.data.user

        if(user.role != 'user' && user.role != 'admin' && user.role != 'adviser' && user.role != 'almacen')
            return toast({message: 'Tipo de usuario no autorizado', type: 'is-danger'})

        userStore.set(resp.data.user)
        replace('#/home')
    }

</script>

<Spinner {loading} />

{#if !loading}
    <form on:submit|preventDefault={login} >
        <div class="field">
            <div class="control has-icons-left" id="email">
                <span class="icon"><i class="fas fa-user"></i></span>
                <input bind:value={data.email} type="text" class="input" placeholder="Correo" required>
            </div>
        </div>
        <div class="field">
            <div class="control has-icons-left" id="email">
                <span class="icon"><i class="fas fa-lock"></i></span>
                <input bind:value={data.password} type="password" class="input" placeholder="Contraseña" required>
            </div>
        </div>
        <div class="items-center space-top">
            <button type="submit" class="button is-primary is-fullwidth">
                <span class="icon"><i class="fas fa-sign-in-alt"></i></span>
                <span>Ingresar</span>
            </button>
        </div>
    </form>
    <br>
    <a href="/files/politica.pdf" target="_blank">Política de Privacidad</a>
{/if}